import { Platform } from "react-native";
import { createPlatformStyles, theme } from "../../theme/theme";

export const { ids, styles } = createPlatformStyles({
  mobile: {
    rowFlex: {
      display: "flex",
      flexDirection: "row",
    },
    colFlex: {
      display: "flex",
      flexDirection: "column",
    },
    divider: {
      width: "100%",
      height: 1,
      borderRadius: 50,
      backgroundColor: theme.colors.black + 35,
    },
    activityIndicator:{
      marginTop:theme.margin.lg,
    },
    billinImage: {
      width: 285,
      height: 400,
      left: -330,
      position: "absolute",
      top: theme.margin.xxl,
      ...Platform.select({
        ios: {
          "@media (min-width: 200px)": {
            display: "none",
          },
          "@media (min-width: 900px)": {
            display: "flex",
          },
        },
        android: {
          "@media (min-width: 200px)": {
            display: "none",
          },
          "@media (min-width: 900px)": {
            display: "flex",
          },
        },
      }),
    },
    claimDetail: {
      zIndex: theme.zIndex.min,
    },
    expandArrow: {
      maxWidth: 20,
    },
    expandData: {
      marginTop: theme.margin.reg,
    },
    arrowDown: {
      width: 13,
      height: 8,
      marginLeft: theme.margin.reg,
    },
    containerFluid: {
      ...Platform.select({
        ios: {
          display: "flex",
          flex: 1,
          minHeight: 300,
        },
        android: {
          display: "flex",
          flex: 1,
          minHeight: 300,
        },
      }),
    },
    scrollArea: {
      ...Platform.select({
        ios: {
          display: "flex",
          flex: 1,
          "@media (min-width: 700px)": {
            paddingHorizontal: theme.spacing.xxl3,
          },
        },
        android: {
          display: "flex",
          flex: 1,
          "@media (min-width: 700px)": {
            paddingHorizontal: theme.spacing.xxl3,
          },
        },
      }),
    },
    topParentView: {
      backgroundColor: theme.colors.primary,
      overflow: "hidden",
      flex: 1,
    },
    paymentHeader: {
      textAlign: "center",
      display: "flex",
      alignItems: "center",
      marginBottom: theme.margin.mmd,
    },
    paymentOf: {
      marginTop: theme.margin.mmd,
      color: theme.colors.white,
      fontWeight: theme.fontweight.medium as any,
      fontSize: theme.fontsize.md,
    },
    makeaPaymentBtn: {
      minWidth: "100%",
      backgroundColor: "grey",
      padding: theme.spacing.reg,
      textAlign: "center",
      display: "flex",
      alignItems: "center",
      borderRadius: theme.radius.sm,
      borderWidth: theme.border.medium,
      marginTop: theme.margin.md,
      marginBottom: theme.margin.xlg,
      borderColor: theme.colors.white,
      fontWeight: theme.fontweight.medium as any,
    },
    btnText: {
      fontFamily: theme.fontFamily.robotoMedium,
      fontWeight: theme.fontweight.medium as any,
      color: theme.colors.white,
      fontSize: theme.fontsize.md,
    },
    marginBottom: {
      marginBottom: theme.margin.reg,
    },
    flexGrow: {
      display: "flex",
      flexGrow: 1,
      minWidth: "100%",
    },
    twoColLayout: {
      minWidth: "50%",
      maxWidth: "50%",
      marginTop: theme.margin.reg,
    },
    textLabelPolicy: {
      marginBottom: theme.margin.sm,
      fontSize: theme.margin.reg,
      color: theme.colors.white,
      paddingLeft: theme.margin.xlg,
    },
    headingText: {
      fontFamily: theme.fontFamily.robotoBold,
      fontSize: theme.fontsize.cs,
      color: theme.colors.white,
    },
    labelText: {
      fontSize: theme.fontsize.cs as any,
      color: theme.colors.text.secondary as any,
      fontFamily: theme.fontFamily.robotoRegular as any,
      fontWeight: theme.fontweight.light as any,
      paddingLeft: theme.spacing.mmd,
    },
    descText: {
      fontSize: theme.fontsize.cs as any,
      color: theme.colors.text.primary as any,
      fontFamily: theme.fontFamily.robotoMedium as any,
    },
    WhiteBoldText: {
      fontWeight: theme.fontweight.regular as any,
    },
    textLabel: {
      fontWeight: theme.fontweight.light as any,
      textAlign: "left",
      maxWidth: "50%",
    },
    labelValue: {
      maxWidth: "50%",
      textAlign: "right",
    },
    policyHolderContainer: {
      marginBottom: theme.margin.reg,
      backgroundColor: theme.colors.white,
      paddingBottom: theme.spacing.reg,
      borderRadius: theme.radius.sm,
      borderTopLeftRadius:0,
      borderTopRightRadius:0,
    },
    listContainer: {
      backgroundColor: theme.colors.white,
      borderRadius: theme.radius.sm,
      width: "100%",
    },
    listHeadingTop: {
      // backgroundColor: theme.colors.black + 50,
      backgroundColor: theme.colors.primaryDark,
      paddingHorizontal: theme.spacing.md,
      paddingVertical: theme.margin.ssm,
      borderTopEndRadius: theme.radius.sm,
      borderTopLeftRadius: theme.radius.sm,
    },

    listItem: {
      backgroundColor: theme.colors.white,
      paddingLeft: theme.spacing.none,
      paddingTop: theme.spacing.sm,
      paddingBottom: theme.spacing.sm,
      paddingRight: theme.spacing.lg,
      color: theme.colors.white,
    },
    listLast: {
      backgroundColor: theme.colors.white,
      paddingLeft: theme.spacing.none,
      paddingRight: theme.spacing.lg,
      paddingTop: theme.spacing.sm,
      color: theme.colors.white,
    },
    listLastBottom: {
      backgroundColor: theme.colors.white,
      paddingLeft: theme.spacing.ssm,
      paddingRight: theme.spacing.lg,
      paddingTop: theme.spacing.sm,
      paddingBottom: theme.spacing.md,
      borderBottomEndRadius: theme.radius.sm,
      borderBottomLeftRadius: theme.radius.sm,
    },
    justifyContent: {
      justifyContent: "space-between",
    },
    docInfoCtr: {
      maxWidth: 600,
      width: "100%",
      position: "relative",
      zIndex: 9,
      ...Platform.select({
        ios: {
          minWidth: "100%",
        },
        android: {
          minWidth: "100%",
        },
      }),
      marginLeft: "auto",
      marginRight: "auto",
      flex: 1,
    },
    choosePolicyText: {
      maxWidth: 600,
      width: "100%",
      marginLeft: "auto",
      marginRight: "auto",
      textAlign: "center",
      alignItems: "center",
      ...Platform.select({
        ios: {
          "@media (min-width: 200px)": {
            paddingLeft: theme.spacing.md,
            display: "flex",
          },
          "@media (min-width: 385px)": {
            paddingLeft: theme.spacing.md,
          },
          "@media (min-width: 700px)": {
            paddingLeft: theme.spacing.none,
            display: "none",
          },
        },
        android: {
          "@media (min-width: 200px)": {
            paddingLeft: theme.spacing.md,
            display: "flex",
          },
          "@media (min-width: 385px)": {
            paddingLeft: theme.spacing.md,
          },
          "@media (min-width: 700px)": {
            paddingLeft: theme.spacing.none,
            display: "none",
          },
        },
      }),
    },
    heading: {
      color: theme.colors.white,
      fontWeight: theme.fontweight.semiBold,
      marginTop: theme.margin.reg,
      ...Platform.select({
        ios: {
          display: "flex",
          "@media (min-width: 200px)": {
            fontSize: theme.fontsize.cs,
          },
          "@media (min-width: 385px)": {
            fontSize: theme.fontsize.md,
          },
          "@media (min-width: 700px)": {
            fontSize: theme.fontsize.mmd,
          },
        },
        android: {
          display: "flex",
        },
      }),
    },
    paymentStatusView: {
      width: "100%",
      padding: theme.spacing.sm,
      paddingHorizontal: theme.spacing.md,
      backgroundColor: theme.colors.policyStatus.paymentStatus,
    },
    paymentStatusText: {fontSize:theme.fontsize.reg,color:theme.colors.policyStatus.paymentStatusColor, fontStyle:"italic"},
  },
  web: {
    divider: {
      width: "100%",
      height: 1,
      borderRadius: 50,
      backgroundColor: theme.colors.black + 35,
    },
    activityIndicator:{
      marginTop:theme.margin.lg,
    },
    rowFlex: {
      display: "flex",
      flexDirection: "row",
    },
    colFlex: {
      display: "flex",
      flexDirection: "column",
    },
    billinImage: {
      width: 285,
      height: 400,
      position: "absolute",
      left: -330,
      top: theme.margin.xxl,
      "@media (min-width: 200px)": {
        display: "none",
      },
      "@media (min-width: 900px)": {
        display: "block",
      },
    },
    claimDetail: {
      zIndex: theme.zIndex.min,
    },
    expandArrow: {
      maxWidth: 20,
    },
    expandData: {
      marginTop: theme.margin.reg,
    },
    arrowDown: {
      width: 14,
      height: 12,
      marginLeft: theme.margin.reg,
    },
    containerFluid: {
      display: "flex",
      flex: 1,
      minHeight: 300,
    },
    scrollArea: {
      position: "absolute",
      top: 70,
      bottom: theme.spacing.none,
      left: theme.spacing.none,
      right: theme.spacing.none,
      height: "90%",
    },
    topParentView: {
      backgroundColor: theme.colors.primary,
      overflow: "hidden",
      flex: 1,
    },
    paymentHeader: {
      textAlign: "center",
      display: "flex",
      alignItems: "center",
      marginBottom: theme.margin.mmd,
    },
    paymentOf: {
      marginTop: theme.margin.mmd,
      color: theme.colors.white,
      fontWeight: theme.fontweight.medium as any,
      fontSize: theme.fontsize.md,
    },
    makeaPaymentBtn: {
      minWidth: "100%",
      backgroundColor: "grey",
      padding: theme.spacing.reg,
      textAlign: "center",
      display: "flex",
      alignItems: "center",
      borderRadius: theme.radius.sm,
      borderWidth: theme.border.medium,
      marginTop: theme.margin.md,
      marginBottom: theme.margin.xlg,
      borderColor: theme.colors.white,
      fontWeight: theme.fontweight.medium as any,
    },
    btnText: {
      fontFamily: theme.fontFamily.robotoMedium,
      fontWeight: theme.fontweight.medium as any,
      color: theme.colors.white,
      fontSize: theme.fontsize.md,
    },
    marginBottom: {
      marginBottom: theme.margin.reg,
    },
    flexGrow: {
      display: "flex",
      flexGrow: 1,
      minWidth: "100%",
    },
    twoColLayout: {
      minWidth: "50%",
      maxWidth: "50%",
      marginTop: theme.margin.reg,
    },
    textLabelPolicy: {
      marginBottom: theme.margin.sm,
      fontSize: theme.margin.reg,
      color: theme.colors.white,
      paddingLeft: theme.margin.xlg,
    },
    headingText: {
      fontFamily: theme.fontFamily.robotoBold,
      fontSize: theme.fontsize.cs,
      color: theme.colors.white,
      fontWeight: theme.fontweight.medium as any,
    },
    labelText: {
      fontSize: theme.fontsize.cs as any,
      color: theme.colors.text.secondary as any,
      fontFamily: theme.fontFamily.robotoRegular as any,
      fontWeight: theme.fontweight.light as any,
      paddingLeft: theme.spacing.mmd,
    },
    descText: {
      fontSize: theme.fontsize.cs as any,
      color: theme.colors.text.primary as any,
      fontFamily: theme.fontFamily.robotoMedium as any,
      ...Platform.select({
        web: {
          fontWeight: theme.fontweight.medium as any,
        },
      }),
    },
    WhiteBoldText: {
      fontWeight: theme.fontweight.regular as any,
    },
    textLabel: {
      fontWeight: theme.fontweight.light as any,
      textAlign: "left",
      maxWidth: "50%",
    },
    labelValue: {
      maxWidth: "50%",
      textAlign: "right",
    },
    policyHolderContainer: {
      marginBottom: theme.margin.reg,
      backgroundColor: theme.colors.white,
      paddingBottom: theme.spacing.reg,
      borderRadius: theme.radius.sm,
      borderTopLeftRadius:0,
      borderTopRightRadius:0,
    },
    listContainer: {
      backgroundColor: theme.colors.white,
      borderRadius: theme.radius.sm,
      width: "100%",
    },
    listHeadingTop: {
      backgroundColor: theme.colors.black + 50,
      paddingHorizontal: theme.spacing.md,
      paddingVertical: theme.margin.ssm,
      borderTopEndRadius: theme.radius.sm,
      borderTopLeftRadius: theme.radius.sm,
    },

    listItem: {
      backgroundColor: theme.colors.white,
      paddingLeft: theme.spacing.none,
      paddingTop: theme.spacing.sm,
      paddingBottom: theme.spacing.sm,
      paddingRight: theme.spacing.lg,
      color: theme.colors.white,
    },
    listLast: {
      backgroundColor: theme.colors.white,
      paddingLeft: theme.spacing.none,
      paddingRight: theme.spacing.lg,
      paddingTop: theme.spacing.sm,
      color: theme.colors.white,
    },
    listLastBottom: {
      backgroundColor: theme.colors.white,
      paddingLeft: theme.spacing.ssm,
      paddingRight: theme.spacing.lg,
      paddingTop: theme.spacing.sm,
      paddingBottom: theme.spacing.md,
      borderBottomEndRadius: theme.radius.sm,
      borderBottomLeftRadius: theme.radius.sm,
    },
    justifyContent: {
      justifyContent: "space-between",
    },
    docInfoCtr: {
      maxWidth: 600,
      width: "100%",
      position: "relative",
      zIndex: theme.zIndex.min,
      minWidth: 600,
      "@media (min-width: 200px)": {
        width: "100%",
        minWidth: "100%",
      },
      "@media (min-width: 700px)": {
        minWidth: 600,
      },
      marginLeft: "auto",
      marginRight: "auto",
      flex: 1,
    },
    choosePolicyText: {
      maxWidth: 600,
      width: "100%",
      marginLeft: "auto",
      marginRight: "auto",
      textAlign: "center",
      alignItems: "center",
      display: "flex",
    },
    heading: {
      color: theme.colors.white,
      fontWeight: theme.fontweight.semiBold,
      marginTop: theme.margin.reg,
      "@media (min-width: 200px)": {
        fontSize: theme.fontsize.cs,
      },
      "@media (min-width: 385px)": {
        fontSize: theme.fontsize.md,
      },
      "@media (min-width: 700px)": {
        fontSize: theme.fontsize.mmd,
      },
    },
    paymentStatusView: {
      width: "100%",
      padding: theme.spacing.sm,
      paddingHorizontal: theme.spacing.md,
      backgroundColor: theme.colors.policyStatus.paymentStatus,
    },
    paymentStatusText: {fontSize:theme.fontsize.reg,color:theme.colors.policyStatus.paymentStatusColor, fontStyle:"italic"},
  },
});
